var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"save-row"},[_c('span',[_vm._v(_vm._s(_vm.folder.name))]),(!_vm.isSaved)?_c('div',{staticClass:"add",on:{"click":_vm.addNewArticleToFolder}},[_c('plus-circle-icon',{attrs:{"size":"16"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }